export const configCollectors = {
  apiKey: 'AIzaSyAWiurMP6pjW5FsyiUmt_lW11ZZFsuQh0Q',
  authDomain: 'neoone.art',
  databaseURL:
  'https://neoone-art-collectors.asia-southeast1.firebasedatabase.app',
  projectId: 'neoone-art',
  appId: '1:697174453188:web:f151ea0d212a6042f01291',
  measurementId: 'G-T6TZXF7LDG',
};
